var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"create-wrap"},[_c('common-bg-plate',[_c('change-chain'),_c('div',{staticClass:"create-content"},[_c('create-retrieval')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }